export default __webpack_public_path__ + "static/media/home-banner.4bd27161.png";